/* eslint-disable consistent-return */
import axios from 'axios';
import { SOCKET_ROOT } from '../config/appConfig';

export const getTopicsApi = async (jwt) => {
  const res = await axios.get(`${SOCKET_ROOT}/topic`, {
    method: 'GET',
    mode: 'cors',
    headers: {
      Authorization: `Bearer ${jwt}`,
      'Content-Type': 'application/json',
    },
  });

  if (res.status === 200) {
    return res.data;
  }
};

export const getTopicByIdApi = async (id, jwt) => {
  const res = await axios.get(`${SOCKET_ROOT}/topic/${id}`, {
    method: 'GET',
    mode: 'cors',
    headers: {
      Authorization: `Bearer ${jwt}`,
      'Content-Type': 'application/json',
    },
  });

  if (res.status === 200) {
    return res.data;
  }
};
